// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___OI8G","col":"styles_col__2Yqpv"};